import { useState, useEffect, type ChangeEvent, type FormEvent } from "react";
import Modal from "@modalSrc/Modal";

type TextInputModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  onSubmit?: (value: string) => void;
  headerText?: string;
  labelText?: string;
  placeholderText?: string;
  buttonText?: string;
  currentValue?: string;
  zIndex?: number | string;
  closeOnSubmit?: boolean;
  className?: string;
};

export default function TextInputModal({
  isOpen,
  onClose,
  onSubmit,
  headerText = "Enter Text",
  labelText = "Text",
  placeholderText = "Enter value...",
  buttonText = "Submit",
  currentValue = "",
  zIndex,
  closeOnSubmit = true,
  className
}: TextInputModalProps) {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (isOpen) {
      setInputValue(currentValue || "");
    }
  }, [isOpen, currentValue]);

  function handleInputChange(e: ChangeEvent<HTMLInputElement>) {
    setInputValue(e.target.value);
  }

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    onSubmit?.(inputValue);
    if (closeOnSubmit) {
      setInputValue("");
      onClose?.();
    }
  }

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={headerText}
      zIndex={zIndex}
      className={className}
      size="sm"
      footer={(
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" form="text-input-modal-form" className="btn btn-primary OkButton" disabled={!inputValue.trim()}>
            {buttonText}
          </button>
        </>
      )}
    >
      <form id="text-input-modal-form" onSubmit={handleSubmit}>
        <label htmlFor="text-input-modal-input">{labelText}</label>
        <input
          id="text-input-modal-input"
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholderText}
          autoFocus
          required
        />
      </form>
    </Modal>
  );
}

